// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"Footer__clearfix___1_lye","cont":"Footer__cont___2yCzl","item":"Footer__item___1Rp2y Footer__clearfix___1_lye","title":"Footer__title___3Fk6r","image":"Footer__image___1yoGq","copyright":"Footer__copyright___1etU0","col":"Footer__col___t_BxC","itemCont":"Footer__itemCont___2jmzS"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Footer/Footer.css
// module id = 741
// module chunks = 0